import { Column, Entity, OneToMany, PrimaryGeneratedColumn, CreateDateColumn, UpdateDateColumn } from "typeorm";
import { SectionWiseModel } from "./section-wise-model.entity";
import { QuestionPapers } from "../../ai-generated-qp/entities/question-papers";

@Entity("question_paper_modal")
export class QuestionPaperModal {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("int", { name: "class" })
  class: number;

  @Column("int", { name: "subject" })
  subject: number;

  @Column("text", { name: "instructions" })
  instructions: string;

  @Column("int", { name: "no_of_sections" })
  noOfSections: number;

  @Column("int", { name: "marks" })
  marks: number;

  @Column("int", { name: "total_questions" })
  totalQuestions: number;

  @Column("int", { name: "time_limit" })
  timeLimit: number;

  @Column("varchar", { name: "tagline", length: 100 })
  tagline: string;

  @Column("varchar", { name: "part_name", length: 100 })
  partName: string;

  @Column("int", { name: "language" })
  language: number;

  @Column("varchar", { name: "blue_print_name" })
  bluePrintName: string;

  @Column("int", { name: "main_model_paper_id" })
  mainModelPaperId: number;

  // @Column('boolean', {
  //   nullable: false,
  //   default: false,
  //   name: 'default_blue_print',
  // })
  // defaultBluePrint: boolean;

  @Column("int", { name: "created_by", nullable: true })
  createdBy: number;

  @Column("varchar", { name: "created_at", nullable: true })
  createdAt: string;

  @OneToMany(() => SectionWiseModel, (sections) => sections.qnpModel, { cascade: true })
  sectionsWiseModel: SectionWiseModel[];

  @OneToMany(() => QuestionPapers, (qp) => qp.qpCode)
  questionPaper: QuestionPapers[];
}
